import React, { useEffect, useState } from 'react';
import { ReactComponent as OfficeBuildingIcon } from '@repo/common/assets/icons/20px/icon_20px_office-building_filled.svg';

function JobCompanyLogo({
  src,
  alt = 'Company logo',
  sizeClassName = 'size-[72px]',
  textClassName = 'typo-b14',
  backgroundClassName = 'bg-grayscale-gray01',
  className = '',
  padding = 'p-[6px]',
}) {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(false);
  }, [src]);

  const showImage = Boolean(src) && !hasError;

  return (
    <div
      className={`relative overflow-hidden rounded border border-grayscale-gray02 shrink-0 ${backgroundClassName} ${sizeClassName} ${className}`}
    >
      {showImage ? (
        <img
          src={src}
          alt={alt}
          className='object-cover w-full h-full'
          onError={() => setHasError(true)}
        />
      ) : (
        <div
          className={`absolute inset-0 flex items-center justify-center ${padding}`}
        >
          <OfficeBuildingIcon
            className={`w-full h-full text-grayscale-gray02 ${textClassName}`}
          />
        </div>
      )}
    </div>
  );
}

export default JobCompanyLogo;
